import { render } from "./detailsMaintenance.vue?vue&type=template&id=5569855a"
import script from "./detailsMaintenance.vue?vue&type=script&lang=js"
export * from "./detailsMaintenance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__